export enum CloudinaryFolders {
  CUSTOMER_AVATARS = "App/customers/avatars",
  DISTRIBUTOR_AVATARS = "App/distributors/avatars",
}
